module.exports = __webpack_public_path__ + "static/media/team-ic.ee9a54e7.svg";